import { render, staticRenderFns } from "./Complement.vue?vue&type=template&id=40cf4558&"
import script from "./Complement.vue?vue&type=script&lang=ts&"
export * from "./Complement.vue?vue&type=script&lang=ts&"
import style0 from "./Complement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports